import React, { useState, useEffect, useRef } from "react";
import Axios from "axios";
import { map } from "lodash";
import { message, Select } from "antd";
import Script from "react-load-script";

import cross_icon from "../../Assets/images/cross_icon.svg";
import { AllState } from "../../Assets/data/stateList.json";

const { Option } = Select;

function AddressEntry(props) {
  const [complete_address, setCompleteAddress] = useState({
    address: "",
    city: "",
    route: "",
    state: "",
    zip_code: "",
    location: "",
    geo_location: null,
    street_number: "",
    formatted_address: "",
  });
  const [is_address_manually, setIsAddressManually] = useState(false);
  const [auto_complete, setAutocomplete] = useState();
  const [report_to_parent, setReportToParent] = useState(false);
  const [is_only_manual, setIsOnlyManual] = useState(false);
  const google_address_ref = useRef(null);
  const [location, setLocation] = useState("");

  useEffect(() => {
    if (google_address_ref) {
      google_address_ref.current.value = "";
    }

    if (props.is_only_manual !== undefined) {
      setIsOnlyManual(props.is_only_manual);
    }
  }, []);

  useEffect(() => {
    is_address_manually
      ? setCompleteAddress({ ...complete_address, location: "" })
      : setCompleteAddress({ ...complete_address, location });
  }, [is_address_manually]);

  useEffect(() => {
    const { address } = props;
    let location = "";
    let temp_complete_address = {};

    if (address?.location !== "" && address?.location !== undefined) {
      location = address?.location;
    } else if (
      address?.formatted_address !== "" &&
      address?.formatted_address !== undefined
    ) {
      location = address?.formatted_address;
    } else if (address?.street_number && address?.route) {
      location = `${address?.street_number} ${address?.route}`;
    } else {
      location = address?.address ? `${address?.address}` : "";
      location += address?.city ? `, ${address?.city}` : "";
      location += address?.state ? `, ${address?.state}` : "";
      location += address?.zip_code ? `, ${address?.zip_code}` : "";
    }
    setLocation(location);

    Object.assign(temp_complete_address, {
      address: address?.address || "",
      state: address?.state || "",
      city: address?.city || "",
      zip_code: address?.zip_code || "",
      location: location,
      formatted_address: location,
      route: address?.route || "",
      street_number: address?.street_number || "",
      geo_location: address?.geo_location || null,
      ...temp_complete_address,
    });

    if (google_address_ref) {
      google_address_ref.current.value = location;
    }

    setReportToParent(false);
    if (is_address_manually) {
      setCompleteAddress({ ...temp_complete_address, location: "" });
    } else {
      setCompleteAddress({ ...temp_complete_address, location });
    }
  }, [props.address]);

  useEffect(() => {
    if (report_to_parent) {
      props.onUpdateAddress(complete_address);
    }
  }, [complete_address]);

  useEffect(() => {
    if (props.reportManuallyAddress) {
      props.onIsManuallyaddressChange(is_address_manually);
    }
  }, [is_address_manually]);

  // Google Map Place API
  const handleScriptLoad = () => {
    // Declare Options For Autocomplete
    const options = { componentRestrictions: { country: "us" } };

    // Initialize Google Autocomplete
    /*global google*/ // To disable any eslint 'google not defined' errors
    const newAutoComplete = new google.maps.places.Autocomplete(
      document.getElementById(`${props.id}`),
      options
    );

    // Avoid paying for data that you don't need by restricting the set of
    // place fields that are returned to just the address components and formatted
    // address.
    newAutoComplete.setFields(["address_components", "formatted_address"]);

    // Fire Event when a suggested name is selected
    newAutoComplete.addListener("place_changed", handlePlaceSelect);

    setAutocomplete({ newAutoComplete });
  };

  const handlePlaceSelect = () => {
    const address = document?.getElementById(`${props.id}`)?.value;

    Axios.get(`https://maps.googleapis.com/maps/api/geocode/json`, {
      params: removeEmpty({
        latlng: undefined,
        address,
        key: process.env.REACT_APP_GOOGLE_PLACE_API_KEY,
      }),
    })
      .then((res) => {
        const google_address_object = res?.data?.results[0];
        let obj = {};

        map(google_address_object?.address_components, (item) => {
          if (
            (item?.types?.includes("route") ||
              item?.types?.includes(
                "administrative_area_level_2" ||
                  item?.types?.includes("premise")
              )) &&
            obj.address === undefined
          ) {
            obj = Object.assign(obj, { address: item.short_name });
          }
          if (item?.types?.includes("route")) {
            obj = Object.assign(obj, { route: item.long_name });
          }
          if (item?.types?.includes("street_number")) {
            obj = Object.assign(obj, { street_number: item.short_name });
          }
          if (item?.types?.includes("administrative_area_level_1")) {
            obj = Object.assign(obj, { state: item.short_name });
          }
          if (item?.types?.includes("locality")) {
            obj = Object.assign(obj, { city: item.long_name });
          }
          if (item?.types?.includes("postal_code")) {
            obj = Object.assign(obj, { zip_code: item.short_name });
          }
        });

        if (google_address_object?.geometry?.location) {
          obj = Object.assign(obj, {
            geo_location: google_address_object?.geometry?.location || null,
          });
        }

        if (google_address_object?.formatted_address) {
          obj = Object.assign(obj, {
            location: google_address_object?.formatted_address,
          });
          obj = Object.assign(obj, {
            formatted_address: google_address_object?.formatted_address,
          });
        }

        if (obj?.address && obj?.route && obj?.street_number) {
          let temp_address = `${obj?.street_number} ${obj.address}`;

          obj = Object.assign(obj, { address: temp_address });
        }
        if (!obj?.address || !obj?.state || !obj.city) {
          message.error("Please enter valid address");
        } else {
          reportAddressToParent({ ...props.address, ...obj });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const reportAddressToParent = (address) => {
    setReportToParent(true);
    setCompleteAddress(address);
  };

  const updateAddress = (e) => {
    let temp_address = { ...complete_address };

    if (e.target.name === props.id) {
      Object.assign(temp_address, {
        formatted_address: e.target.value,
        location: e.target.value,
      });
    } else {
      Object.assign(temp_address, { [e.target.name]: e.target.value });
    }

    if (is_address_manually) {
      let formatted = "";
      formatted += `${
        temp_address?.address && temp_address?.address !== ""
          ? temp_address?.address
          : ""
      }`;
      formatted += `${
        temp_address?.city && temp_address?.city !== ""
          ? ", " + temp_address?.city
          : ""
      }`;
      formatted += `${
        temp_address?.state && temp_address?.state !== ""
          ? ", " + temp_address?.state
          : ""
      }`;
      formatted += `${
        temp_address?.zip_code && temp_address?.zip_code !== ""
          ? ", " + temp_address?.zip_code
          : ""
      }`;
      setLocation(formatted);

      Object.assign(temp_address, {
        formatted_address: formatted,
        location: "",
      });
    }

    reportAddressToParent(temp_address);
  };

  const removeEmpty = (obj) => {
    return Object.fromEntries(
      Object.entries(obj).filter(([_, v]) => v !== null && v?.trim() !== "")
    );
  };

  // Render all states
  const renderAllState = () => {
    return AllState.map((item, i) => {
      return (
        <Option value={item.abbreviation} key={i}>
          {item.name}
        </Option>
      );
    });
  };

  // Validate numeric input
  const onNumericInputChange = (value) => {
    const reg = /^-?\d*(\.\d*)?$/;
    return (!isNaN(value) && reg.test(value)) || value === "" || value === "-";
  };

  const cleanAddress = () => {
    const clean_address = {
      address: "",
      city: "",
      route: "",
      state: "",
      zip_code: "",
      ggeo_location: null,
      street_number: "",
      formatted_address: "",
    };
    setCompleteAddress(clean_address);
    reportAddressToParent(clean_address);
  };

  const renderGoogleMapsInput = () => {
    return (
      <div className="google_search_place mb-10">
        <Script
          url={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_PLACE_API_KEY}&libraries=places`}
          onLoad={() => window.requestAnimationFrame(handleScriptLoad)}
        />

        <input
          auto_complete="off"
          type="text"
          className={
            is_address_manually
              ? "google_search_disable form--control"
              : "form--control"
          }
          placeholder="Search for address"
          name={`${props.id}`}
          id={`${props.id}`}
          ref={google_address_ref}
          defaultValue={complete_address?.location || ""}
          value={complete_address?.location}
          onChange={(e) => {
            e.target.value ? updateAddress(e) : cleanAddress();
          }}
          disabled={is_address_manually}
        />
        <b>
          or{" "}
          <a
            href="/"
            onClick={(e) => {
              e.preventDefault();
              setIsAddressManually(true);
            }}
          >
            <u>enter address manually</u>
          </a>
          <br></br>
        </b>
      </div>
    );
  };

  const renderManualAddressForm = () => {
    return (
      <div className="manually_address">
        {!is_only_manual && (
          <a
            href="/#"
            onClick={(e) => {
              e.preventDefault();
              setIsAddressManually(false);
              if (
                props?.address?.address === "" ||
                props?.address?.address === undefined
              ) {
                cleanAddress();
              }
            }}
          >
            <img src={cross_icon} alt="" className="float-right mb-10" />
          </a>
        )}

        <br />

        <div className="billing_control">
          <div className="single_control">
            <input
              type="text"
              placeholder="Address"
              className="form--control"
              name="address"
              value={complete_address?.address || ""}
              onChange={(e) => updateAddress(e)}
            />
          </div>
        </div>
        <div className="billing_control">
          <div className="multi_control mr-2 mt-2">
            <input
              type="text"
              className="form--control"
              placeholder="City"
              name="city"
              value={complete_address?.city || ""}
              onChange={(e) => updateAddress(e)}
            />
          </div>
          <div className="multi_control mr-2 mt-2">
            <Select
              showArrow={true}
              name="state"
              placeholder="State"
              onChange={(value) =>
                updateAddress({ target: { name: "state", value } })
              }
              value={complete_address?.state || undefined}
              virtual={false}
            >
              {renderAllState()}
            </Select>
          </div>
          <div className="multi_control mt-2">
            <input
              type="text"
              className="form--control"
              placeholder="ZIP Code"
              name="zip_code"
              maxLength={5}
              minLength={5}
              onChange={(e) => {
                onNumericInputChange(e.target.value);
                updateAddress(e);
              }}
              value={complete_address?.zip_code || ""}
            />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="address-entry">
      {!is_only_manual && renderGoogleMapsInput()}
      {is_address_manually || is_only_manual ? renderManualAddressForm() : null}
    </div>
  );
}

export default AddressEntry;
